module.exports = __webpack_public_path__ + "img/strategy_prew_1.227de725.png";